import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { FormArray, FormControl, FormGroup, FormBuilder, ReactiveFormsModule, Validators, AbstractControl } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePickerModule } from 'primeng/datepicker';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { PanelModule } from 'primeng/panel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TextareaModule } from 'primeng/textarea';
import { attachmentLabels, billers, categories, categoriesInExpectedOrder, levels, states, titles, AccountNames, OrderOwners, accountNames, orderOwners, ClientNames, BillToNames, billToNames } from './order-info.model';
import { DoumentUploadService } from '../services/doucument-upload-service/doument-upload.service';
import _ from 'lodash';
import { ModalComponent } from '../shared/modal/modal.component';
import { CustomFormControl } from '../shared/shared.model';
import { IPSAuthenticationService, IPSTenantKeyService } from '@ips/common-angular';
import { DocumentDeleteService } from '../services/document-delete-service/document-delete.service';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { ProgressBarModule } from 'primeng/progressbar';
// For dynamic progressbar demo
import { ToastModule } from 'primeng/toast';
import { LoaderService } from '../services/loader-service/loader.service';
import { LoaderComponent } from "../loader/loader.component";
import { MessageService } from 'primeng/api';
import { environment } from '@env/environment';
import { OrderService } from 'com.trumbull.phx.order.api-client';
import { VocabHelperService } from '../services/vocab-helper/vocab-helper.service';
import { UserHelperService } from '../services/user-helper/user-helper.service';
import { DateMaskDirective } from '../shared/directive/date-mask.directive';
import { SanitizePasteDirective } from '../shared/directive/sanitize-paste.directive';
import { InputMaskModule } from 'primeng/inputmask';
import { CleanStepPanelAccessibilityDirective } from './accesibility.directive';
import { AttachmentsComponent } from '../shared/components/attachments/attachments.component';
import { DropdownModule } from 'primeng/dropdown';
import { ContactListService } from 'com.trumbull.phx.contactlist.api-client';
import { ContactHelperService } from '../services/contact-helper/contact-helper.service';


@Component({
  selector: 'app-order-info',
  imports: [InputTextModule, DatePickerModule, RadioButtonModule, CommonModule,
    ReactiveFormsModule, SelectModule, PanelModule, CardModule, InputNumberModule,
    CheckboxModule, FileUploadModule, ButtonModule, TextareaModule,ToastModule,
    TableModule, ModalComponent, CascadeSelectModule, ProgressBarModule, ToastModule, DateMaskDirective, InputMaskModule, AttachmentsComponent, CleanStepPanelAccessibilityDirective, DropdownModule, SanitizePasteDirective],
  templateUrl: './order-info.component.html',
  styleUrl: './order-info.component.scss',
  providers: [MessageService]
})

export class OrderInfoComponent implements OnInit, AfterViewInit {
  @ViewChild('stepHeading') stepHeading!: ElementRef;
  @ViewChildren('contactHeaders') contactHeaders!: QueryList<ElementRef>;
  
  @Input() formData: any;
  @Input() states: any;
  @Input() editOrder: any;
  @Output() orderTypeChange = new EventEmitter<string>();
  @Output() validateForm = new EventEmitter<boolean>();
  @Output() formChanged = new EventEmitter<void>();
  dateOfIncidentDatePicker: Date;
  formGroup!: FormGroup;
  loggedinUserName: string = "";
  loggedinUserPhone: any = "";
  loggedinUserPhoneExtn: string = "--";
  loggedinUserEmail: string = "";
  tenantName: string = "";
  billToEmail: string = "billtoemail@walmart.com";
  showBarInputField: boolean = false;
  elementIndex: number[] = [];
  showBarNoDiv: number[] = [];
  recordFile: any;
  showDeleteModal: boolean = false;
  showFileDeleteModal: boolean = false;
  itemToDelete: any;
  // contactNames:any[] = [];
  showContactDropdown:boolean = true;
  contactNames:any = [];
  contactList:any = [];
  adjusterList:any = [];
  billerList:any = [];
  adjusterNames:any = [];
  billerNames:any = [];

  // attachmentForm: FormGroup;
  attachments: any[] = [];
  selectedFile!: File;

  categories = environment.noAuth? categories : [];
  levels = environment.noAuth? levels : [];
  titles = environment.noAuth? titles : [];
  billers = environment.noAuth? billers : [];
  // states = states;
  attachmentLabels = attachmentLabels;
  // attachments = attachments;
  // form: FormGroup;
  showDescription = false;
  itemFileToDelete: number | null = null;
  fileUpload: any;
  // isLoading: boolean = false;
  private orderInfoAttentionToChangesSubscription: any;
  private orderInfoAttentionToFirmNameChangesSubscription: any;
  maxDate: Date = new Date();
  fileSizeError: boolean = false;
  maxFileSize: number = 104857600;
  isUploadDisabled: boolean = true;
  categoriesInExpectedOrder = categoriesInExpectedOrder;
  isUserLinkedToAccount: boolean = false; //true when logged in user does not have any account associated.
  accountNames: AccountNames[] = environment.noAuth ? accountNames : [];
  billToNames: BillToNames[] = environment.noAuth? billToNames : [];
  clientNames: ClientNames[] = [];
  clientNamesVocab: any[] = [];
  orderOwners: OrderOwners[] = environment.noAuth? orderOwners : [];
  usersList: any = [];
  selectedTenant?: string | null;
  extractedContacts: any[] = [];
  extractedAdjusters: any[] = [];
  extractedBillers: any[] = [];
  clientContactListId: any;
  accountContactListId: any;
  providerId: string = "standard";
  formSubmissionAttempted = false;

  constructor(
    private fb: FormBuilder, 
    private readonly vocabHelperService: VocabHelperService, 
    private readonly documentUploadSercive: DoumentUploadService, 
    private readonly authService: IPSAuthenticationService,
    private readonly orderService: OrderService, 
    private readonly documentDeleteService: DocumentDeleteService, 
    private readonly loaderService: LoaderService,
    private readonly tenantKeyService: IPSTenantKeyService,
    private messageService: MessageService,
    private userService: UserHelperService,
    private cdr: ChangeDetectorRef,
    private contactListService: ContactListService,
    private readonly contactHelperService: ContactHelperService
  ) {
    this.dateOfIncidentDatePicker = new Date();
    // this.form = this.fb.group({
    //   orderInfoAttachmentLabel: ['', Validators.required],
    //   orderInfoAttachmentExplanation: ['']
    // });
  }

  /**
   * Initializes the form group and sets default values.
   */


  ngOnInit(): void {
    this.formGroup = new FormGroup({
      'orderInfoRefNum': new CustomFormControl(null, 'Claim Number', [Validators.required]),
      'orderInfoDate': new CustomFormControl(null, 'Date of Incident', [Validators.required]),
      'orderInfoClientName': new CustomFormControl( null, 'Client Name', [Validators.required]),
      'selectedCategory': new CustomFormControl(null, 'Type of Order', [Validators.required]),
      'selectedLevel': new FormControl(null),
      'orderInfoBillTo': new CustomFormControl(null, 'Bill To', [Validators.required]),
      // 'orderInfoBillToEmail': new FormControl({ value: this.billToEmail,  disabled: true }),
      'orderInfoBillToEmail': new CustomFormControl( { value: null, disabled: true }, 'Billing Email Address', [Validators.required, Validators.email]),
      'showOrderInfoBillToDropdown': new FormControl(true),
      'orderInfoBillToInput': new FormControl(''),
      'orderInfoBillToDropdown': new FormControl(null),
      'orderInfoAdjusterEmail': new CustomFormControl(null, 'Adjuster Email Address', [Validators.email]),
      'orderInfoAdjusterName': new CustomFormControl(null, 'Adjuster Name', [Validators.required]),
      'showAdjusterDropdown': new FormControl(true),
      'adjusterInput': new FormControl(''),
      'adjusterDropdown': new FormControl(null),
      'isSpecialDeliveryRequired': new FormControl(false),
      'orderInfoAttentionTo': new CustomFormControl(null, 'Attention To'),
      'orderInfoAttentionToFirmName': new CustomFormControl(null, 'Firm Name'),
      'orderInfoAttentionToFirmPhone': new FormControl(null),
      'orderInfoAttentionToFirmPhoneExtn': new FormControl(null),
      'orderInfoAttentionToFirmAddress': new CustomFormControl(null, 'Street Address'),
      'orderInfoAttentionToFirmCity': new CustomFormControl(null, 'City'),
      'orderInfoAttentionToFirmState': new CustomFormControl(null, 'State'),
      'orderInfoAttentionToFirmZip': new CustomFormControl(null, 'Zip'),
      'orderInfoAttachmentFile': new FormControl(null),
      'orderInfoAttachmentLabel': new CustomFormControl(null, 'Label'),
      'orderInfoAttachmentExplanation':  new CustomFormControl(null, 'Attachment Description'),
      'orderInfoSpecialInstructions': new FormControl(null),
      'contacts': new FormArray([this.createContactFormGroup()]),
      'orderInfoAccountName': new CustomFormControl(null, 'Account Name'),
      'orderInfoOrderOwner': new CustomFormControl(null, 'Order Owner'),
      'orderInfoBillingToKeys': new FormControl(null),
      'orderInfoAttentionToKeys': new FormControl(null),
      'orderInfoAdjusterKeys': new FormControl(null),
      'clientContactListId': new FormControl(null),
      'accountContactListId': new FormControl(null),
      'caseMatter': new CustomFormControl(null, 'Case Matter'),

    });

    // Case Matter toggle based on Client Name
    const clientCtrl = this.formGroup.get('orderInfoClientName');
    const caseMatterCtrl = this.formGroup.get('caseMatter');

  if (caseMatterCtrl) {
    caseMatterCtrl.disable({ emitEvent: false });
  }

  if (clientCtrl && caseMatterCtrl) {
    clientCtrl.valueChanges.subscribe((clientCode: string) => {
      
      const isWalmart = clientCode?.toLowerCase() === 'walmart';

      if (isWalmart) {
        caseMatterCtrl.enable({ emitEvent: false });
        caseMatterCtrl.setValidators([Validators.required]);
        //caseMatterCtrl.updateValueAndValidity({ emitEvent: false });
      } else {
        caseMatterCtrl.reset(null, { emitEvent: false });
        caseMatterCtrl.clearValidators();
        caseMatterCtrl.disable({ emitEvent: false });
      }
      caseMatterCtrl.updateValueAndValidity({ emitEvent: false });
    });
  
  }

  this.formGroup.get('showAdjusterDropdown')?.valueChanges.subscribe(() => {
    this.updateAdjusterNameFromSource();
    this.updateAdjusterValidators();
  });

  this.formGroup.get('adjusterInput')?.valueChanges.subscribe(() => {
    const useDropdown = !this.formGroup.get('showAdjusterDropdown')?.value;
    if (useDropdown) {
      this.formGroup.get('orderInfoAdjusterName')?.setValue(this.formGroup.get('adjusterInput')?.value || null);
    }
  });

  this.formGroup.get('adjusterDropdown')?.valueChanges.subscribe(value => {
    const useDropdown = this.formGroup.get('showAdjusterDropdown')?.value;
    if (useDropdown) {
      this.formGroup.get('orderInfoAdjusterName')?.setValue(value?.name || null);
    }
  });  

  this.formGroup.get('showOrderInfoBillToDropdown')?.valueChanges.subscribe(() => {
    this.updateBillToNameFromSource();
    this.updateBillToValidators();
  });

  this.formGroup.get('orderInfoBillToInput')?.valueChanges.subscribe(() => {
    const useDropdown = !this.formGroup.get('showOrderInfoBillToDropdown')?.value;
    if (useDropdown) {
      this.formGroup.get('orderInfoBillTo')?.setValue(this.formGroup.get('orderInfoBillToInput')?.value || null);
    }
  });

  this.formGroup.get('orderInfoBillToDropdown')?.valueChanges.subscribe(value => {
    const useDropdown = this.formGroup.get('showOrderInfoBillToDropdown')?.value;
    if (useDropdown) {
      this.formGroup.get('orderInfoBillTo')?.setValue(value?.name || null);
    }
  });

  // Initialize the state properly
  this.updateAdjusterNameFromSource();
  this.updateAdjusterValidators();

    this.authService.currentUser.forEach(user => {
      this.tenantKeyService.getTenantKey().subscribe((selectedTenant) => {
        this.selectedTenant = selectedTenant;
      });
      this.loggedinUserName = user.definition?.firstName + ' ' + user.definition?.lastName;
      this.loggedinUserEmail = user.definition?.email ?? '';
      this.loggedinUserPhone = user.definition?.phone ?? '';
      let organizationValue: any = user?.definition?.attributes?.find(item => item?.key === 'organization' && item?.tenantKey?.toLowerCase() === this.selectedTenant?.toLowerCase());
      if (organizationValue?.value) { 
        this.isUserLinkedToAccount = true;
        this.formGroup.get('orderInfoAccountName')?.clearValidators();  
        this.formGroup.get('orderInfoAccountName')?.updateValueAndValidity(); 
        this.formGroup.get('orderInfoOrderOwner')?.clearValidators();  
        this.formGroup.get('orderInfoOrderOwner')?.updateValueAndValidity();
        this.formGroup.get('orderInfoAccountName')?.setValue(organizationValue?.value);
        this.formGroup.get('orderInfoOrderOwner')?.setValue(user?.definition?.principalName);
        this.prePopulateFirstContact();
      } else {
        this.isUserLinkedToAccount = false;
        this.getUserList();
        this.formGroup.get('orderInfoAccountName')?.setValidators(Validators.required);    
        this.formGroup.get('orderInfoAccountName')?.updateValueAndValidity();
        this.formGroup.get('orderInfoOrderOwner')?.setValidators(Validators.required);    
        this.formGroup.get('orderInfoOrderOwner')?.updateValueAndValidity();
      }

      this.fetchContactsByClientName(organizationValue?.value);
    });

    this.tenantKeyService.getTenantKey().subscribe(tenantKey => {
      if (!tenantKey)
        return;

      this.tenantName = tenantKey;
    });

    this.subscribeValueChanges();

    // Subscribe to special delivery toggle changes
    this.formGroup.get('isSpecialDeliveryRequired')?.valueChanges.subscribe(value => {
      if (value === false) {
        this.clearDeliveryInformationFields();
      }
    });

    this.vocabHelperService.getVocabData(['OrderType', 'ContactTitle', 'DocumentCode', 'UserOrganization', 'RecordRetrievalCustomerCode']).subscribe({
      next: (data) => {
        if (data) {
          const vocabOrderData = data.find(d => d.vocabularyName === 'OrderType');
          if (vocabOrderData) {
            let orderVocab = vocabOrderData.vocabularyItems.map(item => ({ name: item.code, description: item.description }));
            if (!_.isEqual(_.sortBy(this.categories, 'name'), _.sortBy(orderVocab, 'name'))) {
              this.categories = _.cloneDeep(orderVocab);
              this.sortCategoriesInExpectedOrder();
            }
          }
          const contactTitleData = data.find(d => d.vocabularyName === 'ContactTitle');
          if (contactTitleData) {
            this.titles = contactTitleData.vocabularyItems.map(item => ({ title: item.description, value: item.code }));
            this.titles = this.sortWithOtherLast(this.titles);
          }
          const serviceLabelData = data.find(d => d.vocabularyName === 'ServiceLevel');
          if (serviceLabelData) {
            this.levels = serviceLabelData.vocabularyItems.map(item => ({ name: item.description, value: item.code }));
          }
          const accountNamesData = data.find(d => d.vocabularyName === 'UserOrganization');
          if (accountNamesData) {
            this.accountNames = accountNamesData.vocabularyItems.map(item => ({ name: item.description, value: item.code }));
          }
          const clientNamesData = data.find(d => d.vocabularyName === 'RecordRetrievalCustomerCode');
          if (clientNamesData) {
            // this.getClientNames(clientNamesData.vocabularyItems);
            this.clientNamesVocab = clientNamesData.vocabularyItems;
            if(this.isUserLinkedToAccount){
              this.getClientNames(this.formGroup.get('orderInfoAccountName')?.value);
            }
          }
        }
      },
      error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'ERROR', detail: 'System error, please contact help desk at EXLRecords.Helpdesk@exlservice.com', sticky: true });
      },
      complete: () => {
        if (this.formData) {
          this.initializeFormData();
        }
      }
    }
    );

    if (this.formData) {
      this.initializeFormData();
    }
    this.formGroup.get('selectedCategory')?.valueChanges.subscribe((newValue) => {
      this.updateBarNumberValidation();
      this.orderTypeChange.emit(newValue);
    }); 

    this.formGroup.valueChanges.subscribe(() => {
      this.formChanged.emit();
    });

  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['formData'])
      this.initializeFormData();
  }
  
    get contactNameControl(): FormControl {
    return this.formGroup.get('contactName') as FormControl;
  }

  onDropdownChange(event: any, index: number) {
    const selected = event.value;
    const group = this.contacts.at(index);

    if (selected === undefined) {
      group.get('showContactDropdown')?.setValue(false);
      group.get('contactDropdown')?.setValue(null);

      ['contactPhone', 'contactPhoneExtn', 'contactEmail', 'contactTitle', 'contactBarNo'].forEach(field => {
        const control = group.get(field);
        control?.enable();
        control?.reset();
      });
      const inputControl = group.get('contactInput');
      const nameControl = group.get('contactName');
      inputControl?.valueChanges.subscribe((val) => {
        nameControl?.setValue(val || '');
      });

    } 
    else if(!selected){
        group.get('contactPhone')?.patchValue(null);
        group.get('contactPhoneExtn')?.patchValue(null);
        group.get('contactEmail')?.patchValue(null);
        group.get('contactTitle')?.patchValue(null);
        group.get('contactBarNo')?.patchValue(null);
        return;
    }
    else {
      group.get('contactDropdown')?.setValue(selected);
      group.get('contactName')?.setValue(selected?.name || '');
      const fullContact = this.extractedContacts.find((item: any) => item.party.id === selected.id);

      if (!fullContact) {
        group.get('contactPhone')?.patchValue(null);
        group.get('contactPhoneExtn')?.patchValue(null);
        group.get('contactEmail')?.patchValue(null);
        group.get('contactTitle')?.patchValue(null);
        group.get('contactBarNo')?.patchValue(null);
        return;
      }

      const locators = fullContact.party?.locators ?? [];
      const workPhone = this.contactHelperService.findWorkPhone(locators);
      const phoneNumber = workPhone.number;
      const phoneExtn = workPhone.extension;
      const email = this.contactHelperService.findWorkEmail(locators);

      const names = fullContact.party?.names ?? [];
      const title = this.contactHelperService.findNameTextByFunction(names, 'title');
      const titleOption = this.titles.find(t => t.value === title);
      const barNumber = this.contactHelperService.findNameTextByFunction(names, 'barNumber');

      group.get('contactPhone')?.patchValue(phoneNumber);
      group.get('contactPhoneExtn')?.patchValue(phoneExtn);
      group.get('contactEmail')?.patchValue(email);
      group.get('contactTitle')?.patchValue(titleOption);
      group.get('contactBarNo')?.patchValue(barNumber);

      // Disable after setting
      group.get('contactPhone')?.disable();
      group.get('contactPhoneExtn')?.disable();
      group.get('contactEmail')?.disable();
      group.get('contactTitle')?.disable();
      group.get('contactBarNo')?.disable();
    }
  }

  onAdjusterChange(event: any): void {
    const selected = event.value;
    const group = this.formGroup;

    if (selected === undefined) {
      group.get('showAdjusterDropdown')?.setValue(false);
      group.get('adjusterDropdown')?.setValue(null);

      const emailControl = group.get('orderInfoAdjusterEmail');
      emailControl?.enable();
      emailControl?.reset();

    } else {
      group.get('adjusterDropdown')?.setValue(selected);

      const fullContact = this.extractedAdjusters.find((item: any) => item.party.id === selected.id);
      if (!fullContact){
        group.get('orderInfoAdjusterEmail')?.patchValue(null);
        return;
      }

      const locators = fullContact.party?.locators ?? [];
      const email = this.contactHelperService.findWorkEmail(locators);

      group.get('orderInfoAdjusterEmail')?.patchValue(email);
      group.get('orderInfoAdjusterEmail')?.disable();
    }
  }

  onBillerChange(event: any): void {
    const selected = event.value;
    const group = this.formGroup;
    if (selected === undefined) {
      group.get('showOrderInfoBillToDropdown')?.setValue(false);
      group.get('orderInfoBillToDropdown')?.setValue(null);
      const emailControl = group.get('orderInfoBillToEmail');
      emailControl?.enable();
      emailControl?.reset();
    } else {
      group.get('orderInfoBillToDropdown')?.setValue(selected);
      const fullContact = this.extractedBillers.find((item: any) => item.party.id === selected.id);
      if (!fullContact){
        group.get('orderInfoBillToEmail')?.patchValue(null);
        return;
      }
      const locators = fullContact.party?.locators ?? [];
      const email = this.contactHelperService.findWorkEmail(locators);
      group.get('orderInfoBillToEmail')?.patchValue(email);
      group.get('orderInfoBillToEmail')?.disable();
    }
  }

  private updateAdjusterNameFromSource(): void {
    const useDropdown = this.formGroup.get('showAdjusterDropdown')?.value;

    if (useDropdown) {
      const dropdownVal = this.formGroup.get('adjusterDropdown')?.value;
      this.formGroup.get('orderInfoAdjusterName')?.setValue(dropdownVal?.name || null);
    } else {
      const inputVal = this.formGroup.get('adjusterInput')?.value;
      this.formGroup.get('orderInfoAdjusterName')?.setValue(inputVal || null);
    }
  }

  private updateBillToNameFromSource(): void {
    const useDropdown = this.formGroup.get('showOrderInfoBillToDropdown')?.value;
    if (useDropdown) {
      const dropdownVal = this.formGroup.get('orderInfoBillToDropdown')?.value;
      this.formGroup.get('orderInfoBillTo')?.setValue(dropdownVal?.name || null);
    } else {
      const inputVal = this.formGroup.get('orderInfoBillToInput')?.value;
      this.formGroup.get('orderInfoBillTo')?.setValue(inputVal || null);
    }
  }

  private updateAdjusterValidators(): void {
    const useDropdown = this.formGroup.get('showAdjusterDropdown')?.value;

    const inputControl = this.formGroup.get('adjusterInput');
    const dropdownControl = this.formGroup.get('adjusterDropdown');

    if (useDropdown) {
      dropdownControl?.setValidators([Validators.required]);
      inputControl?.clearValidators();
    } else {
      inputControl?.setValidators([Validators.required]);
      dropdownControl?.clearValidators();
    }

    dropdownControl?.updateValueAndValidity();
    inputControl?.updateValueAndValidity();
  }

  private updateBillToValidators(): void {
    const useDropdown = this.formGroup.get('showOrderInfoBillToDropdown')?.value;
    const inputControl = this.formGroup.get('orderInfoBillToInput');
    const dropdownControl = this.formGroup.get('orderInfoBillToDropdown');
    if (useDropdown) {
      dropdownControl?.setValidators([Validators.required]);
      inputControl?.clearValidators();
    } else {
      inputControl?.setValidators([Validators.required]);
      dropdownControl?.clearValidators();
    }

    dropdownControl?.updateValueAndValidity();
    inputControl?.updateValueAndValidity();
  }

  getClientNames(account: any) {
   this.orderService.getCustomers('standard', account).subscribe({
    next: (clients) => {
      this.clientNames = clients?.map((clientName: any) => {
        const matchedItem = this.clientNamesVocab?.find((item: any) => item.code === clientName.id);
        return matchedItem ? { name: matchedItem.description, value: matchedItem.code } : null;
      }).filter(item => item !== null); 

       if (this.clientNames?.length === 1) {
         this.formGroup.get('orderInfoClientName')?.setValue(this.clientNames[0].value);
         this.onClientNameSelection(this.clientNames[0].value);
       } else 
          this.formGroup.get('orderInfoClientName')?.setValue('');
    },
    error: (error) => {
      console.error(error);
      },
    });
  }
  
  sortWithOtherLast(list: any):[] {
    return list?.sort((a: any, b: any) => {
      if (a.value.toLowerCase() === 'other') return 1;
      if (b.value.toLowerCase() === 'other') return -1;
      return a.value.localeCompare(b.value);
    });
  }


  isAttentionToOrFirmNameFilled(): boolean {
    return !!this.formGroup.get('orderInfoAttentionTo')?.value || !!this.formGroup.get('orderInfoAttentionToFirmName')?.value;
  }

  /**
   * Called after the view has been initialized. add focus to the top header
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.stepHeading.nativeElement.focus();
    });
  }

  setRequiredValidators() {
    const isSpecialDeliveryRequired = this.formGroup.get('isSpecialDeliveryRequired')?.value;
    const orderInfoAttentionTo = this.formGroup.get('orderInfoAttentionTo');
    const orderInfoAttentionToFirmName = this.formGroup.get('orderInfoAttentionToFirmName');
    const orderInfoAttentionToFirmAddress = this.formGroup.get('orderInfoAttentionToFirmAddress');
    const orderInfoAttentionToFirmCity = this.formGroup.get('orderInfoAttentionToFirmCity');
    const orderInfoAttentionToFirmState = this.formGroup.get('orderInfoAttentionToFirmState');
    const orderInfoAttentionToFirmZip = this.formGroup.get('orderInfoAttentionToFirmZip');

    // Only set validators if special delivery is required AND fields are being filled
    if (isSpecialDeliveryRequired === true && (orderInfoAttentionTo?.value || orderInfoAttentionToFirmName?.value)) {
      this.unsubscribeValueChanges();

      orderInfoAttentionTo?.setValidators([Validators.required]);
      orderInfoAttentionToFirmName?.setValidators([Validators.required]);
      orderInfoAttentionToFirmAddress?.setValidators([Validators.required]);
      orderInfoAttentionToFirmCity?.setValidators([Validators.required]);
      orderInfoAttentionToFirmState?.setValidators([Validators.required]);
      orderInfoAttentionToFirmZip?.setValidators([Validators.required]);

      orderInfoAttentionToFirmName?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionToFirmAddress?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionToFirmCity?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionToFirmState?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionToFirmZip?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionTo?.updateValueAndValidity({ emitEvent: false });
      this.subscribeValueChanges(); 
    }
  }

  clearRequiredValidators() {
    const orderInfoAttentionTo = this.formGroup.get('orderInfoAttentionTo');
    const orderInfoAttentionToFirmName = this.formGroup.get('orderInfoAttentionToFirmName');
    const orderInfoAttentionToFirmAddress = this.formGroup.get('orderInfoAttentionToFirmAddress');
    const orderInfoAttentionToFirmCity = this.formGroup.get('orderInfoAttentionToFirmCity');
    const orderInfoAttentionToFirmState = this.formGroup.get('orderInfoAttentionToFirmState');
    const orderInfoAttentionToFirmZip = this.formGroup.get('orderInfoAttentionToFirmZip');

    if (!orderInfoAttentionTo?.value && !orderInfoAttentionToFirmName?.value) {
      this.unsubscribeValueChanges();

      orderInfoAttentionTo?.clearValidators();
      orderInfoAttentionToFirmName?.clearValidators();
      orderInfoAttentionToFirmAddress?.clearValidators();
      orderInfoAttentionToFirmCity?.clearValidators();
      orderInfoAttentionToFirmState?.clearValidators();
      orderInfoAttentionToFirmZip?.clearValidators();

      orderInfoAttentionToFirmName?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionToFirmAddress?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionToFirmCity?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionToFirmState?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionToFirmZip?.updateValueAndValidity({ emitEvent: false });
      orderInfoAttentionTo?.updateValueAndValidity({ emitEvent: false });

      this.subscribeValueChanges(); 
    }
  }

  // Unsubscribe to prevent the valueChanges events from firing while updating validators
  private unsubscribeValueChanges() {
    if (this.orderInfoAttentionToChangesSubscription) {
      this.orderInfoAttentionToChangesSubscription.unsubscribe();
    }
    if (this.orderInfoAttentionToFirmNameChangesSubscription) {
      this.orderInfoAttentionToFirmNameChangesSubscription.unsubscribe();
    }
  }

  private subscribeValueChanges() {
    this.orderInfoAttentionToChangesSubscription = this.formGroup.get('orderInfoAttentionTo')?.valueChanges.subscribe(value => {
      if (value) {
        this.setRequiredValidators();
      } else {
        this.clearRequiredValidators();
      }
    });

    this.orderInfoAttentionToFirmNameChangesSubscription = this.formGroup.get('orderInfoAttentionToFirmName')?.valueChanges.subscribe(value => {
      if (value) {
        this.setRequiredValidators();
      } else {
        this.clearRequiredValidators();
      }
    });
  }

  // isAttentionToFilled(): boolean {
  //   return !!this.formGroup.get('orderInfoAttentionTo')?.value;
  // }

  /**
   * Creates a new contact form group.
   * @returns A new FormGroup for a contact.
   */


   createContactFormGroup(item?: any): FormGroup {
    let showDropdown = true;
    if (item) {
      if (item.hasOwnProperty('showContactDropdown')) {
        showDropdown = item.showContactDropdown;
      } else if (item.contactDropdown) {
        showDropdown = true;
      } else if (item.contactInput) {
        showDropdown = false;
      } else {
        showDropdown = false;
        item.contactInput = item?.contactName;
      }
    }

    const contactNameValue = showDropdown
      ? item?.contactDropdown?.name || ''
      : item?.contactInput || item?.contactName || '';

    const group = new FormGroup({
      showContactDropdown: new FormControl(showDropdown),
      contactDropdown: new FormControl(item ? item.contactDropdown : null),
      contactInput: new FormControl(item ? item.contactInput : ''),
      contactName: new FormControl(contactNameValue, [Validators.required]),
      contactPhone: new CustomFormControl(
      item?.contactPhone ?? null,
      'Phone',
      [Validators.required]
      ),
      contactPhoneExtn: new FormControl(item?.contactPhoneExtn ?? null),
      contactEmail: new CustomFormControl(
        item?.contactEmail ?? null,
        'Contact Email',
        [Validators.required, Validators.email]
      ),
      contactTitle: new CustomFormControl(
        item?.contactTitle ?? null,
        'Title',
        [Validators.required]
      ),
      contactBarNo: new CustomFormControl(
        item?.contactBarNo ?? null,
        'Bar Number'
      ),
      isNew: new FormControl(item ? item.isNew : true),
      keys: new FormControl(item ? item.keys : null),
    });

    (group.get('contactName') as any).displayName = 'Contact Name';
    const shouldEnable = !!item; 
    const fieldsToToggle = ['contactPhone', 'contactPhoneExtn', 'contactEmail', 'contactTitle'];
    const fieldsRequired = ['contactName','contactPhone', 'contactEmail', 'contactTitle'];
    fieldsToToggle.forEach(field => {
      const control = group.get(field);
      if (!control) return;
      if (fieldsRequired.includes(field)) {
        if (shouldEnable && !showDropdown) {
          control.enable({ emitEvent: false });
          control.setValidators([Validators.required]);
          control.updateValueAndValidity({ emitEvent: false });
        } else {
          control.disable({ emitEvent: false });
          control.clearValidators();
          control.updateValueAndValidity({ emitEvent: false });
        }
      } else {
        if (shouldEnable && !showDropdown) {
          control.enable({ emitEvent: false });
        } else {
          control.disable({ emitEvent: false });
        }
      }
    });

    const inputControl = group.get('contactInput');
    const nameControl = group.get('contactName');
    if (inputControl && nameControl) {
      inputControl.valueChanges.subscribe((val) => {
        nameControl.setValue(val || '', { emitEvent: false });
      });
    }

    return group;
  }


  markControlsAsDirty() {
    this.formGroup.markAllAsTouched();
    this.formGroup.markAsDirty();
  }

checkValidateContactFields(){
  let contactsValid = true;
  const fieldsToValidate = ['contactName','contactPhone', 'contactEmail', 'contactTitle'];
  this.contacts.controls.forEach((groupCtrl: AbstractControl) => {
    const group = groupCtrl as FormGroup;

    Object.keys(group.controls).forEach(key => {
      const control = group.get(key);
      if (control && fieldsToValidate.includes(key)) {
        if(control.disabled){
          control.enable({ emitEvent: false }); 
        }
        if (!control.validator) { 
            control.setValidators([Validators.required]);
            control.updateValueAndValidity({ emitEvent: false });
          }
        if (control.invalid) {
          contactsValid = false;
        }
      }
    });
  });

  if (!contactsValid) {
    this.formGroup.setErrors({ contactsInvalid: true });
  } else {
    this.formGroup.setErrors(null);
  }
}

validate() {
  this.markControlsAsDirty();
  this.checkValidateContactFields();
  this.validateForm.emit(this.formGroup.valid);
}


  /**
   * Gets the contacts form array.
   * @returns The FormArray of contacts.
   */
  get contacts(): FormArray {
    return this.formGroup?.get('contacts') as FormArray;
  }

  /**
   * Adds a new contact to the contacts form array.
   */
  addNewContact(): void {
    this.contacts.push(this.createContactFormGroup());

    this.cdr.detectChanges();
    setTimeout(() => {
      const headersArray = this.contactHeaders.toArray();
      const newHeader = headersArray[headersArray.length - 1];
      newHeader.nativeElement.focus();
    },2);
  }

  /**
   * Removes a contact from the contacts form array.
   * @param index The index of the contact to remove.
   */
  showContactDeletionModal(index: number) {
    this.showDeleteModal = true;
    this.itemToDelete = index;
  }

  confirmContactDeletion() {
    if (this.itemToDelete != null) {
      this.contacts?.removeAt(this.itemToDelete);
      this.itemToDelete = null;
      this.showDeleteModal = false;
      this.messageService.add({
        severity: 'success',
        summary: 'SUCCESS',
        detail: `Contact successfully deleted.`,
        life: 3000,
      });
    }

  }

  /**
   * Pre populate the first contact's form controls.
   */
  prePopulateFirstContact(): void {
    const firstContact = this.contacts?.at(0);
    if (firstContact) {
      firstContact.patchValue({
        contactName: this.loggedinUserName,
        contactPhone: this.loggedinUserPhone,
        contactPhoneExtn: this.loggedinUserPhoneExtn,
        contactEmail: this.loggedinUserEmail
      });    
      // firstContact.get('contactName')?.disable({ onlySelf: true });
      // firstContact.get('contactPhone')?.disable({ onlySelf: true });
      // firstContact.get('contactPhoneExtn')?.disable({ onlySelf: true });
      // firstContact.get('contactEmail')?.disable({ onlySelf: true }); 
    }
  }

  /**
   * Handles the selection of a contact title and updates the form controls accordingly.
   * @param value The selected title value.
   * @param index The index of the contact.
   */
  onTitleSelection(value: string, index: number) {
    const selectedTitle = value;

    if (selectedTitle === 'Attorney') {
      this.elementIndex[index] = index;
      this.showBarNoDiv[index] = 0;
    } else if (selectedTitle === 'Paralegal') {
      this.elementIndex[index] = index;
      this.showBarNoDiv[index] = 1;
    }
    this.updateBarNumberValidation();
  }


  /**
   * Highlights a record for validation.
   */
  // isError(item: any) {
  //   let control = this.formGroup.get(item);
  //   return control ? (control.invalid && (control.dirty || control.touched)) : false;
  // }

  isError(controlId: any, control?: any) {
    let formControl = this.formGroup.get(controlId);
    if (!formControl)
      formControl = control.get(controlId);
    return formControl ? (formControl.invalid && (formControl.dirty || formControl.touched || this.formSubmissionAttempted)) : false;
  }

  // isError(controlId: string, group: FormGroup){
  //   const formControl = group.get(controlId);

  //   return formControl ? (formControl.invalid && (formControl.dirty || formControl.touched || this.formSubmissionAttempted)) : false;
  // }

  initializeFormData() {
    if (this.formData?.contacts) {
      this.contacts?.clear();
      _.forEach(this.formData.contacts, contacts => {
        this.contacts?.push(this.createContactFormGroup(contacts));
      });
    }

    this.formGroup?.patchValue({
      orderInfoRefNum: this.formData.orderInfoRefNum,
      orderInfoDate: this.formData.orderInfoDate,
      orderInfoClientName: this.formData.orderInfoClientName,
      selectedCategory: this.formData.selectedCategory,
      selectedLevel: this.formData.selectedLevel,
      orderInfoBillToEmail: this.formData.orderInfoBillToEmail,
      orderInfoAdjusterEmail: this.formData.orderInfoAdjusterEmail,
      orderInfoBillTo: this.formData.orderInfoBillTo,
      showOrderInfoBillToDropdown: this.formData.showOrderInfoBillToDropdown,
      orderInfoBillToInput: this.formData.orderInfoBillToInput,
      orderInfoBillToDropdown: this.formData.orderInfoBillToDropdown,
      orderInfoAdjusterName: this.formData.orderInfoAdjusterName,
      showAdjusterDropdown: this.formData.showAdjusterDropdown,
      adjusterInput: this.formData.adjusterInput,
      adjusterDropdown: this.formData.adjusterDropdown,
      orderInfoBillingToKeys: this.formData.orderInfoBillingToKeys,
      orderInfoAdjusterKeys: this.formData.orderInfoAdjusterKeys,
      orderInfoAttentionToKeys: this.formData.orderInfoAttentionToKeys,
      isSpecialDeliveryRequired: this.formData.isSpecialDeliveryRequired,
      orderInfoAttentionTo: this.formData.orderInfoAttentionTo,
      orderInfoAttentionToFirmName: this.formData.orderInfoAttentionToFirmName,
      orderInfoAttentionToFirmPhone: this.formData.orderInfoAttentionToFirmPhone,
      orderInfoAttentionToFirmPhoneExtn: isNaN(this.formData.orderInfoAttentionToFirmPhoneExtn) ? '' : this.formData.orderInfoAttentionToFirmPhoneExtn,
      orderInfoAttentionToFirmAddress: this.formData.orderInfoAttentionToFirmAddress,
      orderInfoAttentionToFirmCity: this.formData.orderInfoAttentionToFirmCity,
      orderInfoAttentionToFirmState: this.formData.orderInfoAttentionToFirmState,
      orderInfoAttentionToFirmZip: this.formData.orderInfoAttentionToFirmZip,
      orderInfoAttachmentFile: this.formData.orderInfoAttachmentFile,
      orderInfoAttachmentLabel: this.formData.orderInfoAttachmentLabel,
      orderInfoAttachmentExplanation: this.formData.orderInfoAttachmentExplanation,
      orderInfoSpecialInstructions: this.formData.orderInfoSpecialInstructions,
      orderInfoAccountName: this.formData.orderInfoAccountName,
      orderInfoOrderOwner: this.formData.orderInfoOrderOwner,
      caseMatter: this.formData.caseMatter
    });

    // Case Matter enabled when client is Walmart on edit
    const clientCode = this.formGroup.get('orderInfoClientName')?.value;
    const caseMatterCtrl = this.formGroup.get('caseMatter');
    const isWalmart = clientCode?.toLowerCase() === 'walmart'; // adjust to actual code

    if (caseMatterCtrl) {
      if (isWalmart) {
        caseMatterCtrl.enable({ emitEvent: false });
        caseMatterCtrl.setValidators([Validators.required]);
      } else {
        caseMatterCtrl.clearValidators();
        caseMatterCtrl.disable({ emitEvent: false });
      }
      caseMatterCtrl.updateValueAndValidity({ emitEvent: false });
    }

    let specialDelivery = this.formData.isSpecialDeliveryRequired;
    // If not present, infer from delivery fields
    if (typeof specialDelivery === 'undefined') {
      specialDelivery = 
            !!(this.formData.orderInfoAttentionTo ||
              this.formData.orderInfoAttentionToFirmName ||
              this.formData.orderInfoAttentionToFirmAddress ||
              this.formData.orderInfoAttentionToFirmCity ||
              this.formData.orderInfoAttentionToFirmState ||
              this.formData.orderInfoAttentionToFirmZip);
    } else if (typeof specialDelivery === 'string') {
      specialDelivery = ['yes', 'true', '1'].includes(specialDelivery.trim().toLowerCase());
    } else if (typeof specialDelivery === 'number') {
      specialDelivery = specialDelivery === 1;
    }
    this.formGroup.get('isSpecialDeliveryRequired')?.setValue(!!specialDelivery);

    // fetch client names based on selected account name
    if (this.formData?.orderInfoAccountName) {
      this.onAccountNameSelection(this.formData?.orderInfoAccountName);
      this.formGroup?.patchValue({
        orderInfoOrderOwner: this.formData.orderInfoOrderOwner
      });
    }
    // fetch bill to names based on selected client
    if (this.formData?.orderInfoClientName && this.billToNames.length === 0) {
      this.onClientNameSelection(this.formData?.orderInfoClientName);
      if (this.formData.orderInfoBillTo === 'Other') {
        this.formGroup.get('orderInfoBillToEmail')?.enable();
      }
    }
    if (this.editOrder) {
      this.formGroup?.get('orderInfoAccountName')?.disable();
      this.formGroup?.get('orderInfoClientName')?.disable();
    }
    this.attachments = this.formGroup?.get('orderInfoAttachmentFile')?.value ? this.formGroup.get('orderInfoAttachmentFile')?.value : [];
    if (this.formGroup) {
      const adjusterName = this.formData?.orderInfoAdjusterName;
      const showDropdown = this.formData?.showAdjusterDropdown ?? !!this.formData?.adjusterDropdown;
      const orderInfoBillTo = this.formData?.orderInfoBillTo;
      const showBillToDropdown = this.formData?.showOrderInfoBillToDropdown ?? !!this.formData?.orderInfoBillToDropdown;

      if (showDropdown) {
        if (this.adjusterNames.length > 0) {
          const matchedAdjuster = this.adjusterNames.find((a: any) =>
            a.name === adjusterName || a.id === adjusterName?.id
          );

          if (matchedAdjuster) {
            this.formGroup.get('adjusterDropdown')?.setValue(matchedAdjuster);
            this.formGroup.get('orderInfoAdjusterName')?.setValue(matchedAdjuster.name);

            const fullContact = this.extractedAdjusters.find((item: any) => item.party.id === matchedAdjuster.id);
            const locators = fullContact?.party?.locators ?? [];
            const email = this.contactHelperService.findWorkEmail(locators);
            this.formGroup.get('orderInfoAdjusterEmail')?.patchValue(email);
            this.formGroup.get('orderInfoAdjusterEmail')?.disable();
          }
        } else {
          this.fetchAdjustersByAccountName(this.formData?.orderInfoClientName);
        }
      } else {
        this.formGroup.get('adjusterInput')?.setValue(adjusterName);
        this.formGroup.get('orderInfoAdjusterName')?.setValue(adjusterName);
        this.formGroup.get('orderInfoAdjusterEmail')?.enable();
      }

      if (showBillToDropdown) {
        if (this.billerNames.length > 0) {
          const matchedBiller = this.billerNames.find((b: any) =>
            b.name === orderInfoBillTo || b.id === orderInfoBillTo?.id
          );
          if (matchedBiller) {
            const group = this.formGroup.get('contacts') as FormArray;
            group.get('orderInfoBillToDropdown')?.setValue(matchedBiller);
            group.get('orderInfoBillToInput')?.setValue(matchedBiller.name);

            const fullContact = this.extractedBillers.find((item: any) => item.party.id === matchedBiller.id);
            if (!fullContact){
              group.get('orderInfoBillToEmail')?.patchValue(null);
              return;
            }
            const locators = fullContact.party?.locators ?? [];
            const email = this.contactHelperService.findWorkEmail(locators);
            group.get('orderInfoBillToEmail')?.patchValue(email);
            group.get('orderInfoBillToEmail')?.disable();
          }
        } else {
          this.fetchAdjustersByAccountName(this.formData?.orderInfoClientName);
        }
      } else {
        this.formGroup.get('orderInfoBillToInput')?.setValue(orderInfoBillTo);
        this.formGroup.get('orderInfoBillToEmail')?.enable();
      }
    }


  }

  // onOrderTypeChange(event: any) {
  //   debugger;
  // }

  cancelUpload(fileupload: any) {
    fileupload.clear();
    fileupload.msgs = [];
    this.fileSizeError = false;
    this.showDescription = false;
    this.fileUpload = null;
    const labelControl = this.formGroup.get('orderInfoAttachmentLabel');
    const explanationControl = this.formGroup.get('orderInfoAttachmentExplanation');
    labelControl?.clearValidators();  
    explanationControl?.clearValidators(); 
    labelControl?.reset();
    explanationControl?.reset();
    labelControl?.markAsPristine();
    labelControl?.markAsUntouched();
    explanationControl?.markAsPristine();
    explanationControl?.markAsUntouched();
    this.isFileUploaded();
    this.isUploadButtonDisabled();
  }

  isFileUploaded(): boolean {
    const control = this.formGroup.get('orderInfoAttachmentLabel');
    const isRequired = control?.hasValidator(Validators.required) ?? false;
    return isRequired;
  }

  onDescriptionChange() {
    this.isUploadButtonDisabled();
  }

  isUploadButtonDisabled() {
    if (!this.fileSizeError && this.fileUpload && this.formGroup.get('orderInfoAttachmentLabel')?.value) {
      if (this.formGroup.get('orderInfoAttachmentLabel')?.value.value === 'OTH' && !this.formGroup.get('orderInfoAttachmentExplanation')?.value) {
        this.isUploadDisabled = true;
        return;
      }
      this.isUploadDisabled = false;
    } else {
      this.isUploadDisabled = true;
    }
  }

  updateBarNumberValidation() {
    const contacts = this.formGroup.get('contacts') as FormArray; 
    contacts.controls.forEach((contact) => {
      const contactTitle = contact.get('contactTitle')?.value?.value;
      const selectedCategory = this.formGroup?.get('selectedCategory')?.value;
      const contactBarNoControl = contact.get('contactBarNo');
      if (selectedCategory === 'subpoena-to-be-prepared' && contactTitle === 'attorney') {
        contactBarNoControl?.setValidators([Validators.required]);
      } else {
        contactBarNoControl?.clearValidators(); 
      }
      contactBarNoControl?.updateValueAndValidity(); 
    });
  }
  
  sortCategoriesInExpectedOrder() {
  const previousCategory = this.formGroup.get('selectedCategory')?.value;
   this.categories.sort((a: any, b: any) => {
     const indexA = this.categoriesInExpectedOrder.indexOf(a.name);
     const indexB = this.categoriesInExpectedOrder.indexOf(b.name);
     if (indexA !== -1 && indexB !== -1) {
         return indexA - indexB;
     }
     if (indexA !== -1) return -1;
     if (indexB !== -1) return 1;
     return 0;
   });
   if (previousCategory) {
    // const prevCategory = this.categories.find(c => c.name === previousCategory.name);
    this.formGroup.patchValue({
      selectedCategory: previousCategory,
    });
    }
  }
  
  getUserList() {
    this.userService
    .getUsersByAttribute(undefined, undefined)
      .subscribe((users) => {
          this.usersList = users;
          if (this.formData?.orderInfoAccountName) {
            this.onAccountNameSelection(this.formData?.orderInfoAccountName)
          }
      });
  }

  onAccountNameSelection(selectedAccount: string, clearOrderOwnerSelection: boolean = false) {
    this.fetchContactsByClientName(selectedAccount);
    this.orderOwners = environment.noAuth ? orderOwners : [];
    if (clearOrderOwnerSelection) {
      this.formGroup.get('orderInfoOrderOwner')?.setValue('');
      this.formGroup.get('orderInfoOrderOwner')?.updateValueAndValidity();  
      this.formGroup.get('orderInfoBillTo')?.setValue('');
      this.formGroup.get('orderInfoBillToEmail')?.setValue('');
      this.formGroup.get('orderInfoBillToEmail')?.disable();
    }
    if(this.usersList && this.usersList.length > 0) {
      this.orderOwners = this.usersList?.filter((user: any) =>
      user.attributes.some((attr: any) =>
        attr.key === 'organization' && attr.value === selectedAccount
      )
    )?.map((user: any) => ({
      name: `${user.firstName} ${user.lastName}`,
      value: user.principalName,
    }));
    }

    if (selectedAccount) {
      this.billToNames = [];
      this.getClientNames(selectedAccount);
    }
  }

  fetchContactsByClientName(accountName: string): void {

      this.contactListService.listContactLists('standard', "", accountName, "account").subscribe((response: any) => {
      const contactLists = response.contactList || []; // Safely get the array

      const contactListObj = contactLists.find(
        (item: any) => item.name === accountName && item.type.toLowerCase() === 'account'
      );

      this.extractedContacts = [];

        if (contactListObj && Array.isArray(contactListObj.contactItems)) {
          this.formGroup.get('accountContactListId')?.setValue(contactListObj.id);
          contactListObj.contactItems.forEach((item: any) => {
            if (item.active) {
              this.extractedContacts.push(item);
            }
          });
        }
      this.contactHelperService.sortByPathInPlace(this.extractedContacts, 'party.displayName');
      this.contactNames = this.contactHelperService.mapToNameIdOptions(this.extractedContacts);

      /*this.contactNames.push({
        name: "Don’t see your results? Click here to add more.",
        isSpecial: true
      });*/
    });
  }

  // get billToNames list as per selected client
  onClientNameSelection(selectedClient: string) {
    if (!selectedClient) return;
    this.billToNames = [];
    const billToVocabName = `${selectedClient}-BillingTo`;
    this.vocabHelperService.getVocabData([billToVocabName]).subscribe({
      next: (data) => {
        if (data) {
          const billToVocabData = data.find(d => d.vocabularyName === billToVocabName);
          if (billToVocabData) {
            this.billToNames = billToVocabData.vocabularyItems?.map(item => ({ name: item?.description?.split(";")[0], email: item?.description?.split(";")[1], value: item?.description?.split(";")[0] }));
            this.billToNames = this.sortWithOtherLast(this.billToNames);
          }
        }
      },
      error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'ERROR', detail: 'System error, please contact help desk at EXLRecords.Helpdesk@exlservice.com', sticky: true });
      },
    }
    );
     this.fetchAdjustersByAccountName(selectedClient);
  }

  fetchAdjustersByAccountName(clientName: string): void {
      this.contactListService.listContactLists('standard', "", clientName, "customer").subscribe((response: any) => {
      const contactLists = response.contactList; 
      
      const clientContactList = contactLists.find(
        (item: any) => item.name === clientName && item.type.toLowerCase() === 'customer'
      );
      this.billerList = [];
      this.extractedBillers = [];
      if (clientContactList && Array.isArray(clientContactList.contactItems)) {
        this.formGroup.get('clientContactListId')?.setValue(clientContactList.id);
        // Filter items that have 'bill-to' tag for billers
        this.billerList = clientContactList.contactItems.filter((item: any) => {
          return item.tags && item.tags.some((tag: any) => 
            tag.tagName && tag.tagName.toLowerCase() === 'bill-to'
          );
        });

        // Store extracted billers
        this.extractedBillers = [...this.billerList];
      }

      this.contactHelperService.sortByPathInPlace(this.extractedBillers, 'party.displayName');
      this.billerNames = this.contactHelperService.mapToNameIdOptions(this.extractedBillers);

      this.adjusterList = [];
      this.extractedAdjusters = [];
      if (clientContactList && Array.isArray(clientContactList.contactItems)) {
      // Filter items that have 'bill-to' tag for billers
        this.adjusterList = clientContactList.contactItems.filter((item: any) => {
          return item.tags && item.tags.some((tag: any) => 
            tag.tagName && tag.tagName.toLowerCase() === 'adjuster'
          );
        });
        this.extractedAdjusters = [...this.adjusterList];
      }
      this.contactHelperService.sortByPathInPlace(this.extractedAdjusters, 'party.displayName');
      this.adjusterNames = this.contactHelperService.mapToNameIdOptions(this.extractedAdjusters);
        /*this.adjusterNames.push({
          name: "Don’t see your results? Click here to add more.",
          isSpecial: true
        });*/
      });
  }

  onBillToSelection(value: any) {
    if (!value) return;
    const selectedBillToDetails = this.billToNames.find((item: any) => item.value === value);
    if (selectedBillToDetails?.email) {
      this.formGroup.get('orderInfoBillToEmail')?.setValue(selectedBillToDetails.email);
      this.formGroup.get('orderInfoBillToEmail')?.disable();
    } else {
      this.formGroup.get('orderInfoBillToEmail')?.setValue('');
      this.formGroup.get('orderInfoBillToEmail')?.enable();
    }
    this.formGroup.get('orderInfoBillToEmail')?.updateValueAndValidity();
  }

  onDateInput(event:any) {
    const rawValue = event.target.value;
    const inputDate = new Date(rawValue);
    if (inputDate > this.maxDate) {
      this.formGroup.get('orderInfoDate')?.setErrors({ maxDateExceeded: true });
    }    
  }

  /**
   * Clears all delivery information fields when special delivery is not required
   */
  clearDeliveryInformationFields(): void {
    this.unsubscribeValueChanges();
    
    this.formGroup.patchValue({
      orderInfoAttentionTo: null,
      orderInfoAttentionToFirmName: null,
      orderInfoAttentionToFirmPhone: null,
      orderInfoAttentionToFirmPhoneExtn: null,
      orderInfoAttentionToFirmAddress: null,
      orderInfoAttentionToFirmCity: null,
      orderInfoAttentionToFirmState: null,
      orderInfoAttentionToFirmZip: null
    }, { emitEvent: false });

    // Clear validators
    this.clearRequiredValidators();
    
    this.subscribeValueChanges();
  }

}
